module.exports = __webpack_public_path__ + "img/anonyma_icon.d76721e8.svg";